module.exports = __webpack_public_path__ + "img/bae2af9.jpg";